export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","sizes":"16x16","href":"/16px.png"},{"rel":"apple-touch-icon","sizes":"16x16","href":"/16px.png"},{"rel":"icon","sizes":"32x32","href":"/32px.png"},{"rel":"apple-touch-icon","sizes":"32x32","href":"/32px.png"},{"rel":"icon","sizes":"46x46","href":"/46px.png"},{"rel":"apple-touch-icon","sizes":"46x46","href":"/46px.png"},{"rel":"icon","sizes":"120x120","href":"/120px.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/120px.png"},{"rel":"icon","sizes":"144x144","href":"/144px.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/144px.png"},{"rel":"icon","sizes":"192x192","href":"/192px.png"},{"rel":"apple-touch-icon","sizes":"192x192","href":"/192px.png"},{"rel":"icon","sizes":"384x384","href":"/384px.png"},{"rel":"apple-touch-icon","sizes":"384x384","href":"/384px.png"},{"rel":"icon","sizes":"512x512","href":"/512px.png"},{"rel":"apple-touch-icon","sizes":"512x512","href":"/512px.png"}],"style":[],"script":[],"noscript":[],"title":"Walbert-Schmitz Styleguide","charset":"utf-8","viewport":"width=device-width, initial-scale=1"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false